<template>
  <section>
    <div class="row" v-if="episode.VL_file_exist === 'Y'">
      <div class="col">
        <h5>{{ $t('series.episode-efile-list.heading.video') }}</h5>
        <a :href="episode.VL_ftp_url" target="_blank" download>{{ episode.VL_filename }}</a>
        ({{ episode.VL_filesize }})
        <p
          v-html="$t('series.episode-efile-list.message.video-file-is-in-rm-format')"
          v-if="episode.VL_filetype === 'rm'"
        ></p>
      </div>
    </div>
    <div class="row" v-if="episode.AL_file_exist === 'Y'">
      <div class="col">
        <h5>{{ $t('series.episode-efile-list.heading.audio') }}</h5>
        <a :href="episode.AL_ftp_url" target="_blank" download>{{ episode.AL_filename }}</a>
        ({{ episode.AL_filesize }})
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

import { AlertPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { LinkPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(AlertPlugin)
Vue.use(ButtonPlugin)
Vue.use(LinkPlugin)

export default {
  i18n,
  name: 'series-audiovisual-list',
  props: {
    episode: {
      type: Object,
      required: true
    }
  },
  methods: {
    // 
  },
  created() {
    // 
  },
  components: {
    // 
  }  
}
</script>